export class Certificate {
    certificateId: number;
    examinationId: number;
    certificationId: number;
    certificationName: string;
    isPrimary: boolean;
    certificateStatus: number;
    awardDateOrRecertifiedDate: Date;
    expirationDate: string;
    awardDate: string;
    certificateNumber: number;
    ccStatus: number;
    ccStatusDisplay: string;
    certificationGeneration: number;
    isOtherBoard: boolean;
    recertifiedDate: string;
    isHPM: boolean;
    isLifeTimeWithTenYear: boolean;
}

export enum CertificateStatus {
    Active = 1,
    Inactive = 2
}


export enum CCStatus {
    Meeting = 1,
    VoluntarilyMeeting = 2,
    NotMeeting = 3,
    NotRequired = 4
}

export enum CertificationGeneration
{
    Lifetime = 1,
    TenYear = 2,
    Cc = 3
}